import { get, put, post } from '@/utils/request'

export const getComplaintDetail = id => get(`complaint/${id}`)
export const getComplaintList = async params => {
  const { data } = await get('complaint', params)
  return data
}
export const finishComplaint = id => put(`complaint/${id}`, { status: 'FINISH' })

export const addComplaint = async params => {
  const { data } = await post('complaint', params)
  return data
}
